import { render } from "./Clock.vue?vue&type=template&id=22124a5a&scoped=true"
import script from "./Clock.vue?vue&type=script&lang=js"
export * from "./Clock.vue?vue&type=script&lang=js"

import "./Clock.vue?vue&type=style&index=0&id=22124a5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22124a5a"]])

export default __exports__